import { HttpClient } from '@common/clients/HttpClient.js';
import { CustomerAttribute } from '@common/customerAttributes/types.js';
import { AuthState } from '@src/store/auth.js';
import type { ConfigState } from '@src/store/config.js';
import { ApiLoadConsentResponse, ConsentSaveType } from '@src/types/common.js';
import { checkScenario } from '@src/util/scenario.js';

export abstract class ClientAbstract {
  protected httpClient: HttpClient;

  protected config: ConfigState;

  protected auth: AuthState;

  constructor(config: ConfigState, auth: AuthState) {
    const {
      apiUri, accessToken: configAccessToken, customerToken, traceid,
    } = config;
    const { accessToken: comsInternalAccessToken } = auth;

    const { isRaittNoTokensWithInterception, isAuthOverride } = checkScenario(config);

    const headers: Record<string, string> = {};

    if (!isRaittNoTokensWithInterception) {
      headers.Authorization = configAccessToken
        ? `Bearer ${configAccessToken}`
        : `Access ${comsInternalAccessToken}`;
    }

    if (isAuthOverride) {
      headers['x-authorization-override'] = customerToken
        ? `Customer ${customerToken}`
        : `Access ${comsInternalAccessToken}`;
    }

    this.httpClient = new HttpClient({
      apiUrl: apiUri,
      headers,
      traceid,
    });
    this.config = config;
    this.auth = auth;
  }

  abstract getConsents(lifecycle: string): Promise<ApiLoadConsentResponse>;
  abstract saveConsents(data: ConsentSaveType[], customerAttributeData: CustomerAttribute[]): Promise<void>;

  getCustomerInfoFromConfigOrAuth(): { lcId?: string, registerId?: string, spId: string } {
    const source = this.auth.spId
      ? this.auth // take details from `GET /token` or `GET /userprofile`
      : this.config; // take details from MF configuration
    return {
      spId: source.spId!,
      lcId: source.lcId,
      registerId: source.registerId,
    };
  }
}
